// extracted by mini-css-extract-plugin
module.exports = {"ecgLoader":"EcgLoaderSmall_ecgLoader__2HZ9x","pulse":"EcgLoaderSmall_pulse__1GVNQ","dash":"EcgLoaderSmall_dash__7wQDy"};